<?xml version="1.0" encoding="utf-8"?>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1041.85 1017.01">
  <path
    fill="#c18166"
    d="M 65.448 1017.01 L 65.532 946.57 L 69.878 946.568 L 422.64 946.905 L 422.667 1015.28 L 65.448 1017.01 Z M 955.615 1015.48 L 595.638 1015.28 L 595.183 946.99 L 953.089 947 L 955.681 946.954 L 955.615 1015.48 Z"
  />
  <path
    fill="#904432"
    d="M 67.579 946.566 L 67.077 936.624 L 422.637 937.692 L 422.64 946.905 L 67.579 946.566 Z M 953.089 947 L 595.183 946.99 L 595.121 938.056 L 953.008 937.982 L 953.089 947 Z"
  />
  <path
    fill="#c18166"
    d="M 65.544 936.637 L 65.641 855.65 L 126.479 855.519 L 126.742 913.407 L 357.134 913.027 L 357.046 854.964 L 422.604 854.808 L 422.637 937.692 L 67.077 936.624 L 67.078 936.641 L 65.544 936.637 Z M 594.548 854.393 L 953.971 854.362 L 955.769 854.394 L 955.689 937.974 L 953.008 937.982 L 595.121 938.056 L 594.548 854.393 Z"
  />
  <path
    fill="#904432"
    d="M 66.894 855.662 L 66.894 846.973 L 126.44 846.886 L 126.479 855.519 L 66.894 855.662 Z M 357.046 854.964 L 357.033 846.549 L 422.601 846.421 L 422.604 854.808 L 357.046 854.964 Z M 954.12 846.186 L 953.971 854.362 L 594.548 854.393 L 594.492 846.203 L 954.12 846.186 Z"
  />
  <path
    fill="#c18166"
    d="M 126.44 846.886 L 65.652 846.965 L 66.116 762.817 L 126.058 762.795 L 126.44 846.886 Z M 422.601 846.421 L 357.033 846.549 L 356.907 762.706 L 422.568 762.681 L 422.601 846.421 Z M 593.918 762.613 L 954.234 762.468 L 955.857 762.457 L 955.777 846.16 L 954.12 846.186 L 594.492 846.203 L 593.918 762.613 Z"
  />
  <path
    fill="#904432"
    d="M 67.611 762.817 L 66.926 754.196 L 126.018 754.074 L 126.058 762.795 L 67.611 762.817 Z M 356.907 762.706 L 356.893 753.598 L 382.321 753.546 L 397.349 753.515 L 422.565 753.464 L 422.568 762.681 L 356.907 762.706 Z M 593.853 753.11 L 954.209 753.081 L 954.234 762.468 L 593.918 762.613 L 593.853 753.11 Z"
  />
  <path
    fill="#c18166"
    d="M 126.018 754.074 L 126.006 754.074 L 65.763 754.185 L 65.867 667.262 L 125.624 667.317 L 126.018 754.074 Z M 356.763 667.561 L 422.522 667.625 L 422.565 753.464 L 356.893 753.598 L 356.763 667.561 Z M 593.268 667.805 L 593.27 667.802 L 954.908 667.854 L 955.948 667.845 L 955.866 753.062 L 954.209 753.081 L 593.853 753.11 L 593.268 667.805 Z"
  />
  <path
    fill="#904432"
    d="M 422.522 667.625 L 356.763 667.557 L 356.754 661.724 L 125.602 662.48 L 125.624 667.317 L 67.498 667.257 L 67.778 659.962 L 954.906 658.273 L 954.908 667.854 L 593.268 667.802 L 593.229 662.105 L 422.529 661.412 L 422.522 667.625 Z"
  />
  <path
    fill="#c18166"
    d="M 66.98 603.659 L 954.851 602.517 L 956.01 602.543 L 955.957 658.282 L 954.906 658.273 L 65.876 659.948 L 65.944 603.646 L 66.978 603.644 L 66.98 603.659 Z"
  />
  <path
    fill="#904432"
    d="M 66.98 603.659 L 66.835 596.303 L 955.049 594.027 L 954.851 602.517 L 66.98 603.659 Z"
  />
  <path
    fill="#c18166"
    d="M 954.049 509.132 L 956.278 509.132 L 956.126 594.048 L 955.049 594.027 L 66.835 596.303 L 65.952 596.277 L 66.056 510.052 L 66.692 510.051 L 66.692 510.058 L 954.049 509.132 Z"
  />
  <path
    fill="#904432"
    d="M 953.864 501.854 L 954.049 509.132 L 66.692 510.058 L 66.404 501.836 L 953.864 501.854 Z"
  />
  <path
    fill="#c18166"
    d="M 67.704 417.031 L 955.257 416.888 L 956.198 501.854 L 953.864 501.854 L 66.404 501.836 L 66.066 501.836 L 66.167 417.03 L 67.704 417.03 L 67.704 417.031 Z"
  />
  <path
    fill="#904432"
    d="M 954.302 407.512 L 954.446 416.887 L 67.704 417.031 L 67.271 408.233 L 954.302 407.512 Z"
  />
  <path
    fill="#c18166"
    d="M 955.225 407.516 L 66.25 408.229 L 66.319 350.743 L 66.263 337.277 L 67.048 320.226 L 76.822 314.683 L 128.007 315.412 L 873.534 315.161 L 929.12 315.142 L 955.323 328.392 L 954.491 347.722 L 954.563 347.713 L 954.563 347.722 L 954.663 356.778 L 955.225 407.516 Z"
  />
  <path
    fill="#904432"
    d="M 916.947 308.987 L 929.119 315.142 L 75.331 315.529 L 90.983 306.651 L 916.947 308.987 Z"
  />
  <path
    fill="#c18166"
    d="M 916.887 308.98 L 916.901 308.987 L 90.937 306.651 L 247.016 218.131 L 738.937 218.998 L 916.887 308.98 Z"
  />
  <path
    fill="#904432"
    d="M 725.858 212.361 L 260.713 210.389 L 247.062 218.131 L 738.983 218.998 L 725.858 212.361 Z"
  />
  <path
    fill="#c18166"
    d="M 260.713 210.389 L 460.57 96.993 L 498.922 97.65 L 725.775 212.361 L 260.713 210.389 Z"
  />
  <path
    fill="#904432"
    d="M 472.288 90.394 L 484.969 90.553 L 499.005 97.65 L 460.653 96.993 L 472.288 90.394 Z"
  />
  <path
    fill="#c18166"
    d="M 478.117 87.088 L 484.969 90.553 L 472.288 90.394 L 478.117 87.088 Z"
  />
  <path
    fill="#3c3d29"
    d="M 67.048 320.226 L 66.263 337.277 L 18.948 337.119 L 478.807 79.068 L 1005.74 341.029 L 954.491 347.722 L 955.323 328.392 L 478.117 87.088 L 67.048 320.226 Z"
  />
  <path
    fill="#3b4232"
    d="M 478.807 79.068 L 18.948 337.119 L 0 297.118 L 159.101 206.891 L 478.206 24.631 L 1023.78 301.629 L 1005.74 341.029 L 478.807 79.068 Z"
  />
  <path
    d="M 478.117 87.088 L 484.969 90.553 L 472.288 90.394 L 478.117 87.088 Z"
    fill="#b76649"
  />
  <path
    d="M 916.947 308.987 L 859.83 308.825 L 682.73 218.899 L 738.983 218.998 L 725.858 212.361 L 669.383 212.122 L 478.708 115.302 L 311.688 210.605 L 260.713 210.389 L 460.653 96.993 L 499.005 97.65 L 916.947 308.987 Z"
    fill="#b76649"
  />
  <path
    d="M 247.062 218.131 L 298.341 218.221 L 143.108 306.798 L 90.983 306.651 L 228.049 228.914 L 247.062 218.131 Z"
    fill="#b76649"
  />
  <path
    d="M 872.32 315.168 L 929.116 315.142 L 929.119 315.142 L 955.323 328.392 L 954.491 347.722 L 954.563 347.713 L 954.563 347.722 L 954.663 356.778 L 954.665 356.98 L 872.32 315.168 Z"
    fill="#b76649"
  />
  <path
    d="M 75.331 315.529 L 127.85 315.505 L 66.318 350.553 L 66.263 337.277 L 67.048 320.226 L 75.331 315.529 Z"
    fill="#b76649"
  />
  <path
    fill="#d19377"
    d="M 986.988 1015.3 L 626.268 1015.29 L 626.478 952.714 L 987.188 952.717 L 986.988 1015.3 Z"
  />
  <path
    fill="#904432"
    d="M 627.998 943.716 L 628.138 952.714 L 986.258 952.717 L 985.478 943.849 L 627.998 943.716 Z"
  />
  <path
    fill="#d19377"
    d="M 626.508 943.716 L 626.798 859.989 L 987.478 857.558 L 987.208 943.847 L 626.508 943.716 Z"
  />
  <path
    fill="#904432"
    d="M 628.268 850.997 L 628.268 859.996 L 986.518 857.519 L 985.868 850.737 L 628.268 850.997 Z"
  />
  <path
    fill="#d19377"
    d="M 987.778 763.312 L 987.498 850.741 L 626.828 850.996 L 627.128 762.826 L 748.647 762.991 L 748.498 823.884 L 859.518 826.165 L 859.757 763.228 L 986.188 763.31 L 987.778 763.312 Z"
  />
  <path
    fill="#904432"
    d="M 627.718 755.729 L 723.388 755.593 L 748.668 755.558 L 748.648 762.992 L 748.648 762.991 L 627.538 762.827 L 627.718 755.729 Z M 986.018 755.232 L 986.188 763.31 L 859.757 763.228 L 859.787 755.482 L 986.018 755.232 Z"
  />
  <path
    fill="#d19377"
    d="M 627.158 755.726 L 627.458 667.247 L 748.878 667.119 L 748.668 755.558 L 627.158 755.726 Z M 988.078 667.182 L 987.798 755.23 L 986.018 755.232 L 859.787 755.482 L 860.122 667.148 L 986.688 667.183 L 986.688 667.182 L 988.078 667.182 Z"
  />
  <path
    fill="#904432"
    d="M 627.618 659.758 L 986.688 658.412 L 986.688 667.183 L 860.118 667.148 L 860.128 665.586 L 748.888 664.967 L 748.878 667.118 L 627.648 667.249 L 627.618 659.758 Z"
  />
  <path
    fill="#d19377"
    d="M 988.098 658.432 L 627.478 659.75 L 627.648 611.704 L 674.648 572.937 L 941.628 572.635 L 987.988 609.364 C 987.988 609.592 988.238 615.024 988.238 615.024 L 988.098 658.432 Z"
  />
  <path
    fill="#904432"
    d="M 681.098 566.382 L 931.018 564.235 L 941.628 572.635 L 673.048 572.939 L 681.098 566.382 Z"
  />
  <path
    fill="#d19377"
    d="M 931.018 564.235 L 895.558 564.54 L 714.908 566.092 L 682.618 566.369 L 793.528 474.894 L 818.128 474.804 L 931.018 564.235 Z"
  />
  <path
    fill="#904432"
    d="M 800.798 468.848 L 810.098 468.446 L 818.128 474.804 L 793.378 474.895 L 800.798 468.848 Z"
  />
  <path
    d="M 805.628 464.908 L 810.098 468.446 L 800.858 468.845 L 805.628 464.908 Z"
    fill="#d19377"
  />
  <path
    fill="#342615"
    d="M 1041.43 598.035 L 1014.58 635.663 L 988.238 615.024 C 988.238 615.024 987.988 609.592 987.988 609.364 L 805.628 464.908 L 627.648 611.704 L 627.618 620.507 L 596.048 627.877 L 806.538 451.733 L 1015.04 626.772 L 1041.85 591.764 L 1041.43 598.035 Z"
  />
  <path
    fill="#3b4232"
    d="M 596.048 627.877 L 806.538 451.733 L 1015.04 626.772 L 1041.85 591.764 L 805.428 396.119 L 571.008 596.196 L 596.048 627.877 Z"
  />
  <path
    d="M 805.628 464.908 L 810.098 468.446 L 800.858 468.845 L 805.628 464.908 Z"
    fill="#b76649"
  />
  <path
    d="M 931.018 564.235 L 895.558 564.54 L 806.668 489.443 L 714.908 566.092 L 682.618 566.369 L 793.528 474.894 L 818.128 474.804 L 931.018 564.235 Z"
    fill="#b76649"
  />
  <path
    d="M 988.238 615.024 L 988.148 642.758 L 905.198 572.676 L 941.628 572.635 L 987.988 609.364 C 987.988 609.592 988.238 615.024 988.238 615.024 Z"
    fill="#b76649"
  />
  <path
    d="M 627.648 611.704 L 674.648 572.937 L 706.748 572.901 L 627.548 639.053 L 627.618 620.507 L 627.648 611.704 Z"
    fill="#b76649"
  />
  <path
    fill="#d19377"
    d="M 530.772 452.929 L 199.092 453.072 C 199.092 452.995 198.992 434.652 198.792 407.654 L 530.622 406.62 L 530.772 452.929 Z"
  />
  <path
    d="M 534.836 472.458 L 202.635 470.35 C 202.635 470.35 199.097 453.084 199.092 453.072 L 530.772 452.929 L 530.655 416.956 L 534.002 416.955 L 534.836 472.458 Z"
    fill="#b76649"
  />
  <path
    fill="#904432"
    d="M 530.192 398.917 L 530.192 406.602 L 199.092 407.662 L 199.092 401.037 L 279.158 400.524 L 279.158 400.689 L 446.592 399.614 L 446.592 399.452 L 530.192 398.917 Z"
  />
  <path
    fill="#d19377"
    d="M 198.392 305.899 L 199.792 305.888 L 199.792 305.911 L 279.334 305.272 L 279.158 400.519 L 198.792 401.02 C 198.592 373.763 198.492 339.198 198.392 305.899 Z M 446.192 303.933 L 450.092 303.902 L 450.092 303.933 L 530.272 303.306 L 530.592 398.953 L 530.192 398.955 L 530.192 398.917 L 446.592 399.452 L 446.592 399.476 L 446.591 399.476 L 446.584 397.913 L 446.192 303.933 Z"
  />
  <path
    d="M 530.622 406.62 L 530.192 406.602 L 530.192 398.956 L 530.592 398.953 L 530.312 315.323 L 532.475 315.322 L 533.865 407.854 L 530.626 407.856 L 530.622 406.62 Z"
    fill="#b76649"
  />
  <path
    fill="#904432"
    d="M 199.792 305.911 L 199.492 297.431 L 279.492 296.917 L 279.492 305.271 L 199.792 305.911 Z M 529.532 295.311 L 529.922 303.261 L 446.192 303.933 L 446.192 295.846 L 529.532 295.311 Z"
  />
  <path
    fill="#d19377"
    d="M 278.792 296.917 L 198.392 297.42 C 198.292 272.034 198.692 207.735 198.692 207.735 L 489.982 206.426 L 529.942 206.273 L 530.242 295.345 L 529.532 295.349 L 529.532 295.311 L 446.192 295.846 L 445.792 218.832 L 279.492 219.646 L 279.492 296.917 L 278.792 296.922 L 278.792 296.917 Z"
  />
  <path
    d="M 530.272 303.306 L 529.922 303.261 L 529.534 295.349 L 530.242 295.345 L 529.984 218.63 L 529.986 218.63 L 532.04 218.633 L 532.363 307.899 L 530.287 307.893 L 530.272 303.306 Z"
    fill="#b76649"
  />
  <path
    fill="#904432"
    d="M 529.562 206.248 L 198.792 207.734 L 198.992 199.123 L 529.452 198.329 L 529.452 198.343 L 529.562 206.248 Z"
  />
  <path
    fill="#d19377"
    d="M 529.452 198.343 L 198.992 199.123 L 199.692 179.684 L 340.392 99.004 L 373.971 98.175 L 529.786 184.18 L 529.452 198.343 Z"
  />
  <path
    fill="#904432"
    d="M 356.192 89.964 L 359.092 89.924 L 373.992 98.174 L 340.392 99.004 L 356.192 89.964 Z"
  />
  <path
    fill="#d19377"
    d="M 357.592 89.134 L 359.025 89.925 L 356.192 89.964 L 357.592 89.134 Z"
  />
  <path
    fill="#3c3d29"
    d="M 168.792 189.852 L 358.792 79.774 L 557.622 189.852 L 570.862 153.164 L 570.275 176.265 L 557.758 210.621 L 529.566 193.51 L 529.786 184.18 L 357.592 89.134 L 199.692 179.684 L 199.53 186.822 L 199.433 186.865 L 178.23 196.301 L 168.792 189.852 Z"
  />
  <path
    fill="#3b4232"
    d="M 155.492 154.664 L 168.792 189.852 L 358.792 79.774 L 557.622 189.852 L 570.862 153.164 L 359.092 33.454 L 155.492 154.664 Z"
  />
  <path
    d="M 357.592 89.134 L 359.092 89.924 L 356.192 89.964 L 357.592 89.134 Z"
    fill="#b76649"
  />
  <path
    d="M 523.382 192.796 L 361.192 100.394 L 199.592 199.114 L 199.592 199.121 L 198.992 199.123 L 199.492 188.47 L 199.53 186.822 L 199.692 179.684 L 340.392 99.004 L 373.972 98.175 L 385.623 104.606 L 524.162 181.079 L 526.242 182.224 L 529.786 184.18 L 529.501 196.283 L 523.382 192.796 Z"
    fill="#b76649"
  />
  <path
    d="M 570.275 176.265 L 569.566 193.875 L 563.481 211.673 L 537.622 211.563 L 531.955 207.158 L 532.05 211.539 L 529.967 211.531 L 529.961 211.53 L 529.96 211.53 L 529.942 206.273 L 529.562 206.248 L 529.452 198.343 L 529.658 189.607 L 529.566 193.51 L 557.758 210.621 L 570.275 176.265 Z"
    fill="#b76649"
  />
  <path
    fill="#262f27"
    d="M 198.692 207.735 C 198.692 207.735 198.692 214.252 198.592 223.956 L 172.692 240.379 L 162.818 204.768 L 177.962 196.118 L 178.23 196.301 L 199.53 186.822 L 199.492 188.47 L 198.992 199.123 L 198.792 207.734 L 198.692 207.735 Z"
  />
  <path
    d="M 558.677 225.723 L 548.177 218.662 L 553.203 218.671 L 555.391 218.674 L 561.084 218.684 L 558.677 225.723 Z"
    fill="#b76649"
  />
  <path
    d="M 838.1 207.356 L 832.363 204.443 L 832.364 204.443 L 836.986 204.217 L 838.11 204.137 L 838.1 207.356 Z"
    fill="#c18166"
  />
  <path
    fill="#904432"
    d="M 836.986 201.955 L 836.986 204.217 L 832.364 204.443 L 828.079 202.267 L 836.986 201.955 Z"
  />
  <path
    d="M 828.078 202.268 L 753.891 164.601 L 836.822 165.182 L 838.033 165.181 L 838.091 201.96 L 836.986 201.955 L 828.079 202.267 L 828.081 202.268 L 828.078 202.268 Z"
    fill="#c18166"
  />
  <path
    fill="#904432"
    d="M 836.822 161.161 L 836.822 165.182 L 753.891 164.601 L 747.115 161.161 L 836.822 161.161 Z"
  />
  <path
    d="M 686.018 130.141 L 686.011 124.366 L 836.959 124.495 L 836.959 124.494 L 837.969 124.495 L 838.027 161.161 L 747.115 161.161 L 686.018 130.141 Z"
    fill="#c18166"
  />
  <path
    d="M 683.334 128.778 L 686.011 124.366 L 686.018 130.141 L 683.334 128.778 Z"
    fill="#b27056"
  />
  <path
    fill="#904432"
    d="M 683.334 128.778 L 681.573 127.884 L 685.97 120.906 L 836.959 121.015 L 836.959 124.495 L 686.011 124.366 L 683.334 128.778 Z"
  />
  <path
    d="M 685.97 120.906 L 685.888 81.168 L 837.899 79.74 L 837.964 121.015 L 685.97 120.906 Z"
    fill="#c18166"
  />
  <path
    d="M 673.952 124.015 L 673.709 102.938 L 673.808 102.783 L 685.888 81.168 L 685.97 120.906 L 681.573 127.884 L 673.952 124.015 Z"
    fill="#b27056"
  />
  <path
    fill="#904432"
    d="M 673.808 102.783 L 673.747 99.436 L 685.795 76.993 L 837.276 75.515 L 837.381 79.737 L 685.888 81.168 L 673.808 102.783 Z"
  />
  <path
    d="M 837.859 54.643 L 837.892 75.517 L 837.276 75.515 L 685.795 76.993 L 685.476 51.678 L 685.343 41.165 L 838.213 40.456 L 837.951 50.937 L 837.859 54.643 Z"
    fill="#c18166"
  />
  <path
    d="M 685.795 76.993 L 673.747 99.436 L 673.672 99.556 L 673.284 65.993 L 685.343 41.165 L 685.795 76.993 Z"
    fill="#b27056"
  />
  <path
    fill="#3c3d29"
    d="M 837.859 54.643 L 838.213 40.456 L 685.343 41.165 L 673.284 65.993 L 657.855 66.703 L 672.718 36.159 L 853.163 36.469 L 853.192 36.469 L 837.859 54.643 Z"
  />
  <path
    fill="#3b4232"
    d="M 672.718 36.159 L 853.204 36.469 L 852.277 0 L 672.409 0.928 L 672.718 36.159 Z"
  />
  <path
    fill="#262f27"
    d="M 657.231 32.725 L 672.409 0.928 L 672.718 36.159 L 657.855 66.703 L 657.231 32.725 Z"
  />
  <path
    d="M 685.476 51.678 L 685.343 41.165 L 838.213 40.456 L 837.951 50.937 L 685.476 51.678 Z"
    fill="#b76649"
  />
  <path
    d="M 685.476 51.678 L 673.337 70.562 L 673.284 65.993 L 685.343 41.165 L 685.476 51.678 Z"
    fill="#9e523b"
  />
  <path
    fill="#ad6c43"
    d="M 593.229 662.105 L 595.651 1015.28 L 581.597 1015.28 L 580.71 672.878 L 433.161 673.772 L 434.492 1015.28 L 422.667 1015.28 L 422.529 661.412 L 593.229 662.105 Z"
  />
  <path
    fill="#ad6c43"
    d="M 356.754 661.724 L 357.134 913.027 L 126.742 913.407 L 125.602 662.48 L 356.754 661.724 Z M 139.784 674.359 L 139.017 777.86 L 235.236 777.477 L 239.069 674.742 L 139.784 674.359 Z M 139.4 791.662 L 139.784 897.846 L 233.702 898.613 L 234.853 792.427 L 139.4 791.662 Z M 251.336 795.494 L 249.691 898.612 L 344.487 898.612 L 343.72 796.261 L 251.336 795.494 Z M 254.785 675.892 L 250.952 777.861 L 344.487 778.244 L 345.637 675.892 L 254.785 675.892 Z"
  />
  <path
    fill="#ad6c43"
    d="M 860.128 665.586 L 859.518 826.165 L 748.498 823.884 L 748.888 664.967 L 860.128 665.586 Z M 760.528 737.178 L 846.918 738.055 L 846.478 679.736 L 761.848 678.421 L 760.528 737.178 Z M 760.088 810.407 L 845.598 812.161 L 846.038 753.841 L 760.528 752.525 L 760.088 810.407 Z"
  />
  <path
    fill="#ad6c43"
    d="M 445.792 218.832 L 446.592 399.614 L 279.158 400.689 L 279.492 219.646 L 445.792 218.832 Z M 369.892 234.812 L 370.992 302.975 L 434.692 303.255 L 433.792 232.848 L 369.892 234.812 Z M 292.692 233.409 L 293.292 303.816 L 355.792 303.255 L 354.992 232.287 L 292.692 233.409 Z M 292.492 317.281 L 293.592 388.249 L 356.392 387.127 L 353.592 318.683 L 292.492 317.281 Z M 370.392 318.683 L 371.292 386.005 L 433.792 387.127 L 433.292 319.244 L 370.392 318.683 Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M 434.492 1015.28 L 433.161 673.772 L 580.71 672.878 L 581.597 1015.28 L 434.492 1015.28 Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M 139.4 791.662 L 139.784 897.846 L 233.702 898.613 L 234.853 792.427 L 139.4 791.662 Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M 251.336 795.494 L 249.691 898.612 L 344.487 898.612 L 343.72 796.261 L 251.336 795.494 Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M 139.784 674.359 L 139.017 777.86 L 235.236 777.477 L 239.069 674.742 L 139.784 674.359 Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M 254.785 675.892 L 250.952 777.861 L 344.487 778.244 L 345.637 675.892 L 254.785 675.892 Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M 760.528 752.525 L 846.038 753.841 L 845.598 812.161 L 760.088 810.407 L 760.528 752.525 Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M 761.848 678.421 L 846.478 679.736 L 846.918 738.055 L 760.528 737.178 L 761.848 678.421 Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M 292.492 317.281 L 293.592 388.249 L 356.392 387.127 L 353.592 318.683 L 292.492 317.281 Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M 370.392 318.683 L 371.292 386.005 L 433.792 387.127 L 433.292 319.244 L 370.392 318.683 Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M 292.692 233.409 L 293.292 303.816 L 355.792 303.255 L 354.992 232.287 L 292.692 233.409 Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M 369.892 234.812 L 370.992 302.975 L 434.692 303.255 L 433.792 232.848 L 369.892 234.812 Z"
  />
  <path
    fill="#262f27"
    d="M 391.423 666.29 L 391.082 681.683 C 399.644 681.421 402.919 689.402 404.291 693.689 C 406.065 699.233 405.369 710.918 405.369 710.918 C 405.369 710.918 415.888 717.899 415.934 721.966 L 403.263 721.982 L 396.233 759.463 L 383.12 759.65 L 378.25 722.427 L 363.964 722.162 C 364.006 718.14 372.828 710.556 372.828 710.556 C 372.828 710.556 372.34 698.42 373.604 693.281 C 374.867 688.146 378.083 682.423 385.923 681.948 L 385.935 666.339 L 391.423 666.29 Z M 384.949 757.324 L 394.489 756.779 L 398.986 723.391 L 381.679 723.119 L 384.949 757.324 Z"
  />
  <path
    fill="#ffd800"
    d="M 381.679 723.119 L 398.986 723.391 L 394.489 756.779 L 384.949 757.324 L 381.679 723.119 Z"
  />
</svg>
